export const VERSION = '0.7.0';
//# sourceMappingURL=version.js.map